import React, { useState, useEffect } from 'react';
import { calculateFeeAmountDeu } from "../services/BondsServices";

// Helper function to format the number with commas and two decimal places
const formatNumber = (value) => {
  // Ensure the value is a number, or return '0.00' if invalid
  let num = parseFloat(value.replace(/[^\d.-]/g, ''));
  if (isNaN(num)) {
    return '0.00';
  }

  // Split into integer and decimal parts
  let [integer, decimal] = num.toFixed(2).split('.');

  // Add commas to the integer part
  integer = integer.replace(/\B(?=(\d{3})+(?!\d))/g, ',');

  return `${integer}.${decimal}`;
};

function CurrencyInput({ field, selectedData, setData, isDisabledBasedOnBusinessLogic }) {
  const [inputValue, setInputValue] = useState("0.00");

  useEffect(() => {
    // Convert the current field value to a number and handle non-numeric cases
    const val = parseFloat(selectedData[field]);
    const numericVal = isNaN(val) ? 0 : val;
    setInputValue(formatNumber(numericVal.toString()));
  }, [selectedData[field]]);

  useEffect(() => {
    setData("fee_amount_due", calculateFeeAmountDeu(selectedData["par_dollar_amount"]), true);
  }, [selectedData["par_dollar_amount"]]);

  const handleChange = (e) => {
    // Get the value and remove any non-numeric characters (except commas and dot)
    const rawValue = e.target.value.replace(/[^\d,\.]/g, '');

    // Set the value to the input field without modifying the formatting
    setInputValue(rawValue);
  };

  const handleBlur = () => {
    // Clean the value and format it when the user exits the input
    const formattedValue = formatNumber(inputValue);
    setInputValue(formattedValue);
    const parsed = parseFloat(formattedValue.replace(/[^\d.-]/g, ''));
    const finalVal = isNaN(parsed) ? 0 : parsed;
    setData(field, finalVal);
  };

  return (
    <div className="input-group">
      <input
        placeholder="0.00"
        type="text"  // Use type="text" to allow for formatted numbers with commas
        value={inputValue}
        onChange={handleChange}
        onBlur={handleBlur}
        className="form-control"
        disabled={isDisabledBasedOnBusinessLogic}
      />
    </div>
  );
}

export default CurrencyInput;